/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarveOutTrackingPresetCounts
 */
export interface CarveOutTrackingPresetCounts {
    /**
     * Count of tracking rows in the Not Submitted preset bucket.
     * @type {number}
     * @memberof CarveOutTrackingPresetCounts
     */
    notSubmitted: number;
    /**
     * Count of tracking rows in the In Review preset bucket.
     * @type {number}
     * @memberof CarveOutTrackingPresetCounts
     */
    inReview: number;
    /**
     * Count of tracking rows in the Following preset bucket.
     * @type {number}
     * @memberof CarveOutTrackingPresetCounts
     */
    following: number;
}

/**
 * Check if a given object implements the CarveOutTrackingPresetCounts interface.
 */
export function instanceOfCarveOutTrackingPresetCounts(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "notSubmitted" in value;
    isInstance = isInstance && "inReview" in value;
    isInstance = isInstance && "following" in value;

    return isInstance;
}

export function CarveOutTrackingPresetCountsFromJSON(json: any): CarveOutTrackingPresetCounts {
    return CarveOutTrackingPresetCountsFromJSONTyped(json, false);
}

export function CarveOutTrackingPresetCountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutTrackingPresetCounts {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'notSubmitted': json['notSubmitted'],
        'inReview': json['inReview'],
        'following': json['following'],
    };
}

export function CarveOutTrackingPresetCountsToJSON(value?: CarveOutTrackingPresetCounts | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'notSubmitted': value.notSubmitted,
        'inReview': value.inReview,
        'following': value.following,
    };
}

